(function () {
  jQuery(function () {
      var $els = $('div[id^=frase]'),
          len = $els.length;

      if (len > 1) {
          var i = 0;
          $els.slice(1).hide();
          setInterval(function () {
              $els.eq(i).fadeOut(500, function () {
                  i = (i + 1) % len;
                  $els.eq(i).css('display', 'flex').fadeIn(500);
              });
          }, 2500);
      }
  });

  const deviceUserAgent = navigator.userAgent.toLowerCase();
  const isMobile = deviceUserAgent.match(/iphone|ipad|ipod|android|blackberry|webos|windows phone/i);

  if (isMobile) {
      const applyEvents = (productCard) => {
          const mainImg = productCard.querySelector('.spc__main-img');
          const hoverImg = productCard.querySelector('.spc__hover-img');
          const productLink = productCard.querySelector('.productLink');

          if (hoverImg) {
              let clicked = false;

              mainImg.addEventListener('touchstart', function () {
                  mainImg.style.opacity = '1';
                  hoverImg.style.opacity = '0';
                  hoverImg.style.display = 'none';
              });

              productLink.addEventListener('click', function (e) {
                  if (!clicked) {
                      e.preventDefault();
                      mainImg.style.opacity = '0';
                      hoverImg.style.opacity = '1';
                      hoverImg.style.display = 'block';
                      clicked = true;
                  } else {
                      window.location.href = productLink.href;
                  }
              });
          }
      };

      const observeNewElements = () => {
          const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                  mutation.addedNodes.forEach((node) => {
                      if (node.nodeType === 1 && node.classList.contains('sf__col-item')) {
                          const productCards = node.querySelectorAll('.sf__pcard-image');
                          productCards.forEach(applyEvents);
                      }
                  });
              });
          });

          observer.observe(document.body, { childList: true, subtree: true });
      };

      const productCards = document.querySelectorAll('.sf__pcard-image');
      productCards.forEach(applyEvents);
      observeNewElements();
  }

  function initializeSlider() {
      const slider = document.getElementById('slider');
      if (!slider) return;

      const slides = document.querySelectorAll('.slide');
      const dots = document.querySelectorAll('.dot');
      let currentSlide = 0;
      let slideInterval = null;

      function updateSlider() {
          slider.style.transform = `translateX(-${currentSlide * 100}%)`;
          dots.forEach(dot => dot.classList.remove('active'));
          dots[currentSlide].classList.add('active');
      }

      dots.forEach(dot => {
          dot.addEventListener('click', function () {
              const clickedSlide = parseInt(this.getAttribute('data-slide'), 10);
              currentSlide = clickedSlide;
              updateSlider();
              restartSlideInterval();
          });
      });

      let initialX = null;

      function handleTouchStart(event) {
          initialX = event.touches[0].clientX;
      }

      function handleTouchMove(event) {
          if (initialX === null) return;

          const currentX = event.touches[0].clientX;
          const diffX = initialX - currentX;

          currentSlide = diffX > 0
              ? (currentSlide + 1) % slides.length
              : (currentSlide - 1 + slides.length) % slides.length;

          updateSlider();
          restartSlideInterval();
          initialX = null;
      }

      slider.addEventListener('touchstart', handleTouchStart);
      slider.addEventListener('touchmove', handleTouchMove);

      updateSlider();

      function restartSlideInterval() {
          if (slideInterval) clearInterval(slideInterval);
          slideInterval = setInterval(() => {
              currentSlide = (currentSlide + 1) % slides.length;
              updateSlider();
          }, 10000);
      }

      restartSlideInterval();
  }

  document.addEventListener('DOMContentLoaded', function () {
      initializeSlider();

      const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
              mutation.addedNodes.forEach(function (node) {
                  if (node.nodeType === 1 && (node.id === 'slider-container' || node.querySelector('#slider-container'))) {
                      initializeSlider();
                  }
              });
          });
      });

      observer.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener("DOMContentLoaded", function () {
      const offerHeader = document.querySelector('.offer-header');
      const couponOffer = document.querySelector('.coupon-offer');
      const couponText = document.querySelector('.coupon-code');

      if (offerHeader && couponOffer && couponText) {
          offerHeader.addEventListener('click', function () {
              couponOffer.classList.toggle('opened');
          });

          couponText.addEventListener('click', function (event) {
              event.stopPropagation();
              const textToCopy = couponText.textContent;

              navigator.clipboard.writeText(textToCopy)
                  .then(() => {
                      const existingMessage = document.querySelector('.message-copy');
                      if (!existingMessage) {
                          const messageElement = document.createElement('div');
                          messageElement.textContent = 'Código copiado!';
                          messageElement.classList.add('message-copy');
                          couponText.parentNode.appendChild(messageElement);
                          setTimeout(() => messageElement.remove(), 2000);
                      }
                  })
                  .catch(err => console.error('Erro ao copiar texto: ', err));
          });

          document.addEventListener('click', function (event) {
              if (!couponOffer.contains(event.target) && !offerHeader.contains(event.target)) {
                  couponOffer.classList.remove('opened');
              }
          });
      }
  });
})();


document.addEventListener('DOMContentLoaded', function() {
    // Pega a URL anterior (referrer)
    const referrer = document.referrer;
    const backDiv = document.getElementById('back-to-collection');
    
    if (referrer.includes('/collections/72-horas-72-produtos-72-reais')) {
        backDiv.style.display = 'flex';
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
  
    if (isMobile) {
      const deferredMedias = document.querySelectorAll('deferred-media[data-auto-play="true"]');
      deferredMedias.forEach((deferredMedia) => {

        if (deferredMedia.loadContent) {
          deferredMedia.loadContent(false);
        }

        const video = deferredMedia.querySelector('video, iframe');
        if (video && video.play) {
          video.play().catch((error) => {
            console.error('Erro ao reproduzir vídeo:', error);
          });
        }
  
        const poster = deferredMedia.querySelector('.deferred-media__poster');
        if (poster) {
          poster.remove();
        }
      });
    }
  });